import { useCreateActiveDealManuallyMutation } from "../../api/dealApi";
import { ActionButtons } from "../ui/ActionButtons";

interface Props {
    empresaId: number;
    onCancelButton?: (cancelAction: boolean) => void;
}

export function ActiveDealOutOfRange({ empresaId, onCancelButton }: Props) {
    const [createDeal, { isLoading }] = useCreateActiveDealManuallyMutation();

    const handleCreateDeal = async () => {
        // TODO: add error handling
        await createDeal(empresaId);
    }

    return (
        <div className="flex flex-col items-center justify-center p-3">
            <p className="text-xl text-center pb-3">¿Esta seguro en crear una nueva campaña?</p>

            <ActionButtons 
                isLoading={isLoading}
                onSave={handleCreateDeal}
                saveButtonType="button"
                saveButtonText="Crear campaña"
                onCancel={()=> {
                    if(onCancelButton)
                        onCancelButton(false);
                    }}
                />
        </div>
    );
}